import React from "react";
import StarRating from "./StarRating";

export default function TestimonialCard({ testimonial }) {
  return (
    <div className="bg-white p-8 card-shadow flex flex-col h-full relative">
      {/* Quote icon */}
      <div className="absolute top-6 right-8 text-primary-100">
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z" />
        </svg>
      </div>

      {/* Stars */}
      <div className="mb-4">
        <StarRating rating={testimonial.rating} />
      </div>

      {/* Quote */}
      <p className="text-gray-600 leading-relaxed text-sm flex-grow mb-6">
        "{testimonial.quote}"
      </p>

      {/* Tour badge */}
      {testimonial.tour && (
        <div className="mb-5">
          <span className="inline-block bg-primary-50 text-primary-700 text-xs font-semibold px-3 py-1 rounded-full">
            {testimonial.tour}
          </span>
        </div>
      )}

      {/* Reviewer */}
      <div className="flex items-center gap-4 pt-5 border-t border-gray-100">
        <img
          src={testimonial.photo}
          alt={testimonial.name}
          className="w-12 h-12 rounded-full object-cover flex-shrink-0"
          onError={(e) => {
            e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
              testimonial.name
            )}&background=4f46e5&color=fff&size=96`;
          }}
        />
        <div>
          <p className="font-bold text-gray-900 text-sm">{testimonial.name}</p>
          <p className="text-gray-400 text-xs">{testimonial.location}</p>
        </div>
      </div>
    </div>
  );
}
